module.exports = __webpack_public_path__ + "img/基·地·中·心.fbb1029b.png";